import styles from "./ToolTip.module.scss";

interface ToolTipProps {
  top: number;
  left: number;
  messages: string[];
  type?: "ERROR" | "INFO";
}

export const ToolTip = ({
  top,
  left,
  messages,
  type = "INFO",
}: ToolTipProps) => {
  return (
    <div
      className={`fade mux-tooltip mux-tooltip-auto show ${type.toLowerCase()}`}
      data-popper-reference-hidden="false"
      data-popper-escaped="false"
      data-popper-placement="top"
      style={{ position: "fixed", top, left }}
    >
      <div
        className={`tooltip-arrow ${type.toLowerCase()} ${styles["tooltip-arrow-more"]}`}
      ></div>
      <div className="mux-tooltip-inner error">
        {messages.map((s) => (
          <div key={s}>{s}</div>
        ))}
      </div>
    </div>
  );
};
